const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'APM_ZABBIX_ITEMS_SUCCESS') {
        return { ...state, [action.actionParams.id]: action.payload };
    }

    if (action.type === 'RESET_APM_ZABBIX_ITEMS') {
        const { [action.payload.id]: removed, ...rest } = state;
        return rest;
    }

    return state;
}

export default reducer;
